<template>
  <div class="funnel-column">
    <div class="funnel-top">
      <h5 class="funnel-title">
        {{ title }}
      </h5>
      <i class="ion-chevron-right" />
    </div>
    <draggable
      v-model="investors"
      class="dragArea"
      :options="draggableOptions"
      :state="state"
      :move="setDraggedColumnName"
      @end="onDragEnd"
    >
      <div
        v-for="(investor, index) in investors"
        v-show="filterByInvestorState(investor)"
        :key="index"
      >
        <InvestorFunnelItem
          :investor="investor"
          :investor-id="investor.id"
          @open-investor-modal="onInvestorFunnelItemClick($event)"
        />
      </div>
    </draggable>
  </div>
</template>

<script>
import draggable from 'vuedraggable'
import InvestorFunnelItem from './InvestorFunnelItem.vue'

export default {
  components: { draggable, InvestorFunnelItem },
  props: {
    title: {
      type: String,
      default: null,
    },
    state: {
      type: String,
      default: null,
    },
    editable: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      draggedColumnName: null,
    }
  },
  computed: {
    investors: {
      get() {
        return this.$store.state.investorList.investors
      },
      set() {},
    },
    draggableOptions() {
      const opts = {
        group: 'funnel',
        dragClass: 'dragged-item',
        disabled: !this.editable,
      }
      return opts
    },
  },
  methods: {
    filterByInvestorState(investor) {
      if (this.title !== 'Investors') return investor.state === this.state

      return !investor.state || investor.state === this.state
    },
    setDraggedColumnName({ relatedContext }) {
      this.draggedColumnName = relatedContext.component.$attrs.state
    },
    onDragEnd(evt) {
      const investorId = evt.item.firstChild.attributes['investor-id'].value
      const investor = this.investors.filter(
        (investor) => investor.id === investorId,
      )[0]
      const status = this.draggedColumnName

      this.$store.dispatch('investorList/classifyInvestor', {
        investor,
        status,
      })
    },
    onInvestorFunnelItemClick(investor) {
      if (investor.id !== null) {
        this.$emit('investor-selected', investor)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import '~assets/css/colors.scss';

.funnel-column {
  margin: 10px 3px;
  flex-basis: 250px;

  .funnel-top {
    display: flex;
    color: $grey60;

    .funnel-title {
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 15px;
      text-align: center;
      margin: 0px auto;
    }

    i {
      font-size: 16px;
      margin-right: -8px;
    }
  }
}

.dragArea {
  height: 100%;
}

.dragged-item {
  border: 1px transparent solid;
}
</style>
